import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2 8.49995L5.59995 14.2C5.19995 14.6 5.19995 15.2 5.59995 15.6C5.99995 16 6.59995 16 6.99995 15.6L12 10.7L17 15.6C17.4 16 18 16 18.4 15.6C18.6 15.4 18.7 15.2 18.7 14.9C18.7 14.6 18.6 14.4 18.4 14.2L12.8 8.49995C12.3 8.09995 11.7 8.09995 11.2 8.49995C11.3 8.49995 11.3 8.49995 11.2 8.49995Z",
		fill: "currentColor"
	})
});
export default SvgChevronUp;
